import { gqlOperation } from '…/app/common/rpc/gqlOperation.mts';

import REMOVE_ME_FROM_WORKSPACE from './removeMeFromWorkspace.gql';

interface RemoveMeFromWorkspaceInput {
  workspaceId: string;
}

interface RemoveMeFromWorkspaceResponse {
  id: string;
  name: string;
}

export function removeMeFromWorkspace({
  workspaceId,
}: RemoveMeFromWorkspaceInput): Promise<RemoveMeFromWorkspaceResponse['id']> {
  return gqlOperation<RemoveMeFromWorkspaceResponse>(REMOVE_ME_FROM_WORKSPACE, {
    workspaceId,
  })
    .then(({ id }) => id);
}
